import { render } from "./Ordini.vue?vue&type=template&id=7c60cacf"
import script from "./Ordini.vue?vue&type=script&lang=js"
export * from "./Ordini.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\nic_cli\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__